import React from 'react'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// icons
import PptIcon from 'src/icons/ppt.svg'
import PdfIcon from 'src/icons/pdf.svg'
// utils
import { size } from 'polished'

// styled
const ExportToPdfIcon = styled(PdfIcon)`
  ${size('30px')};
`

const ExportToPptIcon = styled(PptIcon)`
  ${size('30px')};
`

const Button = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  margin: 8px;
`
const Content = styled('div')`
  color: ${colors.gray400};
  display: flex;
  flex-direction: column;
  margin-left: 8px;

  > span:last-child {
    font-size: 12px;
  }
`

const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  flex: 1;
  font-size: 16px;
  font-weight: bold;
  height: 32px;
  justify-content: space-between;
  position: relative;
`

const Wrapper = styled('div')`
  padding: 8px;

  > div:first-child {
    font-size: 14px;
    justify-content: center;
    margin-bottom: 16px;
  }
`
export { ExportToPdfIcon, ExportToPptIcon, Button, Content, Header, Wrapper }
